module.exports = __webpack_public_path__ + "static/media/o3.fdd0705c.svg";